import { i18n } from '@/plugins/i18n'
import { collectiveStatusStr, collectiveVariant } from '@/constants/collectiveStatus';


export default [
    {
        field: 'id',
        width: 60,
        title: i18n.t('label.identifier'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'account_number',
        width: 120,
        title: i18n.t('label.accounting_account_id'),
        sortable: false,
        textAlign: 'center',
    },
    // sheba number
    // {
    //     field: 'account_number',
    //     width: 90,
    //     title: i18n.t('label.accounting_account_number'),
    //     sortable: false,
    //     textAlign: 'center',
    // },
    {
        field: 'company',
        width: 60,
        title: i18n.t('label.accounting_company_id'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'status',
        width: 60,
        title: i18n.t('label.status'),
        sortable: false,
        template: (row) => {
            if (! row.status) {
                return '<div>-</div>'
            }

            let status = row.status == 2 ? 'موفق' : 'ناموفق'
            let variant = row.status == 2 ? 'badge-success' : 'badge-danger';

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        textAlign: 'center',
    },
    {
        field: 'balance_discrepancy_status',
        width: 90,
        title: i18n.t('accounting.label.balance_discrepancy_status'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'count_discrepancy_status',
        width: 90,
        title: i18n.t('accounting.label.count_discrepancy_status'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'analysis_period',
        width: 100,
        title: i18n.t('accounting.label.analysis_period'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'last_analysis',
        width: 80,
        title: i18n.t('accounting.label.last_analysis'),
        sortable: false,
        textAlign: 'center',
    },
]